<template>
  <div class="delivery-list">
    <div class="header-container">
      <h1>配送管理</h1>
      <button class="btn btn-secondary" @click="goBack">返回</button>
    </div>

    <div v-if="loading" class="loading">加载中...</div>

    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>
    
    <div v-if="success" class="alert alert-success">
      {{ success }}
    </div>

    <table v-if="!loading && deliveries.length > 0">
      <thead>
        <tr>
          <th>配送单号</th>
          <th>购买人</th>
          <th>商品</th>
          <th>数量</th>
          <th>物流服务商</th>
          <th>配送状态</th>
          <th>创建时间</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="delivery in deliveries" :key="delivery.id">
          <td>{{ delivery.deliveryCode }}</td>
          <td>{{ delivery.order?.name || '未知' }}</td>
          <td>{{ delivery.order?.product?.name || '未知商品' }}</td>
          <td>{{ delivery.order?.quantity || 1 }}</td>
          <td>{{ delivery.logisticsProvider?.name || '未知' }}</td>
          <td>
            <span :class="getDeliveryStatusClass(delivery.deliveryStatus)">{{ getDeliveryStatusText(delivery.deliveryStatus) }}</span>
          </td>
          <td>{{ formatDate(delivery.createdAt) }}</td>
          <td>
            <button v-if="delivery.deliveryStatus === '待发货'" class="btn btn-sm" @click="markAsShipped(delivery.id)">标记为已发货</button>
            <span v-else>已处理</span>
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="!loading && deliveries.length === 0" class="alert alert-danger">
      暂无配送单记录
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeliveryList',
  data() {
    return {
      deliveries: [],
      loading: true,
      error: '',
      success: ''
    }
  },
  created() {
    this.fetchDeliveries()
  },
  methods: {
    async fetchDeliveries() {
      try {
        this.loading = true
        const sellerId = localStorage.getItem('sellerId')
        const sellerUsername = localStorage.getItem('sellerUsername')
        const headers = {
          'X-Username': sellerUsername
        }
        
        if (!sellerId) {
          this.error = '请先登录'
          return
        }
        
        const response = await this.$axios.get(`/deliveries/seller/${sellerId}`, {
          headers: headers
        })
        
        if (response.data.success) {
          this.deliveries = response.data.deliveries
        } else {
          this.deliveries = []
        }
        this.error = ''
      } catch (err) {
        let errorMessage = '获取配送单失败'
        if (err.response) {
          errorMessage = err.response.data?.message || `服务器错误: ${err.response.status}`
        } else if (err.request) {
          errorMessage = '服务器无响应，请检查网络连接'
        } else {
          errorMessage = `请求错误: ${err.message}`
        }
        this.error = errorMessage
        this.deliveries = []
      } finally {
        this.loading = false
      }
    },
    async markAsShipped(deliveryId) {
      try {
        const sellerUsername = localStorage.getItem('sellerUsername')
        const headers = {
          'X-Username': sellerUsername
        }
        
        const response = await this.$axios.put(`/deliveries/${deliveryId}/ship`, null, {
          headers: headers
        })
        
        if (response.data.success) {
          this.success = '已标记为发货！'
          // 刷新列表
          await this.fetchDeliveries()
          setTimeout(() => {
            this.success = ''
          }, 3000)
        }
      } catch (err) {
        this.error = err.response?.data?.message || '标记发货失败'
        setTimeout(() => {
          this.error = ''
        }, 10000)
      }
    },
    getDeliveryStatusText(status) {
      switch (status) {
        case '待发货': return '待发货'
        case '已发货': return '已发货'
        case '已送达': return '已送达'
        case '取消': return '已取消'
        default: return '未知状态'
      }
    },
    getDeliveryStatusClass(status) {
      switch (status) {
        case '待发货': return 'delivery-pending'
        case '已发货': return 'delivery-shipped'
        case '已送达': return 'delivery-delivered'
        case '取消': return 'delivery-cancelled'
        default: return 'delivery-unknown'
      }
    },
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    goBack() {
      this.$router.push('/seller/dashboard')
    }
  }
}
</script>

<style scoped>
.loading {
  text-align: center;
  padding: 2rem;
  font-size: 1.2rem;
}

.delivery-list {
  overflow-x: auto;
  padding: 0 1rem;
}

table {
  width: 100%;
  min-width: 1000px;
  border-collapse: collapse;
  margin-top: 1rem;
  font-size: 0.9rem;
}

th, td {
  border: 1px solid #ddd;
  padding: 0.8rem 0.5rem;
  text-align: left;
  white-space: nowrap;
}

th {
  background-color: #f8f9fa;
  font-weight: bold;
  font-size: 0.85rem;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.btn {
  padding: 0.25rem 0.5rem;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 0.3rem;
  margin-bottom: 0.3rem;
  display: inline-block;
  font-size: 0.8rem;
}

.btn:hover {
  background: #218838;
}

.btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.btn:disabled:hover {
  background: #ccc;
}

.btn-secondary {
  background: #6c757d;
}

.btn-secondary:hover {
  background: #545b62;
}

.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

h1 {
  margin-bottom: 0;
}

.delivery-pending {
  color: #ffc107;
  font-weight: bold;
}

.delivery-shipped {
  color: #28a745;
  font-weight: bold;
}

.delivery-delivered {
  color: #17a2b8;
  font-weight: bold;
}

.delivery-cancelled {
  color: #dc3545;
  font-weight: bold;
}

.delivery-unknown {
  color: #6c757d;
  font-weight: bold;
}

.alert {
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 4px;
}

.alert-danger {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.alert-success {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.btn-sm {
  padding: 0.2rem 0.4rem;
  font-size: 0.85rem;
}
</style>